import { z } from 'zod';

const MensajeLicitacionSchema = z.object({
  id: z.string().nullable(),
  fecha_creacion: z.string().nullable(),
  mensaje: z.string().nullable(),
  licitacion_id: z.number().nullable(),
  usuario_autor: z.string().nullable(),
  fecha_actualizacion: z.string().nullable(),
  activo: z.boolean().nullable()
});

export const ListarMensajesLicitacionesResponseSchema = z.array(MensajeLicitacionSchema);

export type ListarMensajesLicitacionesResponse = z.infer<typeof ListarMensajesLicitacionesResponseSchema>;
export type MensajeLicitacion = z.infer<typeof MensajeLicitacionSchema>; 